import React, { useCallback } from 'react';
import { createFormField } from 'Shared/utils/createFormField';
import { AnyObject } from 'react-final-form';
import isNaN from 'lodash/isNaN';
import pick from 'lodash/pick';
import { WpIcon } from 'Wpds/components/icon';

function checkNumberValue(value, min, max, prevValue) {
  const number = Number(value);

  if (isNaN(number)) return prevValue || min;
  if (['', undefined, null].includes(value)) return min;
  if (number < min) return min;
  if (number > max) return max;
  return number;
}

const InputWhiteProps = Object.freeze(['onBlur', 'onFocus', 'className']);

function NumberInput({ onChange, min, max, value: fieldValue, ...rest }: AnyObject) {
  const handleChange = useCallback(
    ({ target: { value } }) => {
      return onChange(checkNumberValue(value, min, max, fieldValue));
    },
    [fieldValue, max, min, onChange]
  );

  const handleInnerSpinClcik = useCallback(() => {
    return onChange(checkNumberValue(fieldValue + 1, min, max, fieldValue));
  }, [fieldValue, max, min, onChange]);

  const handleOuterSpinClcik = useCallback(() => {
    return onChange(checkNumberValue(fieldValue - 1, min, max, fieldValue));
  }, [fieldValue, max, min, onChange]);

  const handleKeyDown = useCallback(
    ({ key }) => {
      if (key === 'ArrowUp') onChange(checkNumberValue(fieldValue + 1, min, max, fieldValue));
      if (key === 'ArrowDown') onChange(checkNumberValue(fieldValue - 1, min, max, fieldValue));
    },
    [fieldValue, max, min, onChange]
  );

  return (
    <div className="position-relative">
      <input
        value={fieldValue}
        type="text"
        onKeyDown={handleKeyDown}
        onChange={handleChange}
        min={min}
        max={max}
        {...pick(rest, InputWhiteProps)}
      />
      <div className="onboarding-mas-input-spins">
        <span className="onboarding-mas-input-inner-spin" onClick={handleInnerSpinClcik}>
          <WpIcon name="chevron-up" />
        </span>
        <span className="onboarding-mas-input-outer-spin" onClick={handleOuterSpinClcik}>
          <WpIcon name="chevron-down" />
        </span>
      </div>
    </div>
  );
}

export default createFormField(NumberInput);
